import { render, staticRenderFns } from "./lainaaheti.vue?vue&type=template&id=25f7a8f2&"
import script from "./lainaaheti.vue?vue&type=script&lang=js&"
export * from "./lainaaheti.vue?vue&type=script&lang=js&"
import style0 from "./lainaaheti.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports